import { Injectable } from '@angular/core';
import { RestaurantProduct } from '../models/restaurant.model';

@Injectable({
  providedIn: 'root',
})
export class FavoriteProductService {

  constructor() {}

  public isFavorite(product: RestaurantProduct, favoriteItems: String[]): boolean {
    return favoriteItems.includes(product.info.id);
  }

  updateFavoriteProducts(
    favoriteItems: String[],
    filteredProductList: RestaurantProduct[][],
    favoriteProducts: RestaurantProduct[],
  ) {
    const favoriteItemsSet = new Set(favoriteItems);
  
    const productsToAdd = [];
    const productsToRemove = [];
  
    for (const subArray of filteredProductList) {
      for (const product of subArray) {
        const isFavorite = favoriteItemsSet.has(product.info.id);
        const isInFavoriteProducts = favoriteProducts.some(
          (fp) => fp.info.id === product.info.id
        );
  
        if (
          isFavorite &&
          !isInFavoriteProducts &&
          !productsToAdd.some((p) => p.info.id === product.info.id)
        ) {
          productsToAdd.push(product);
        } else if (!isFavorite && isInFavoriteProducts) {
          productsToRemove.push(product);
        }
      }
    }
  
    if (productsToAdd.length) {
      favoriteProducts = [...favoriteProducts, ...productsToAdd];
    }
  
    if (productsToRemove.length) {
      favoriteProducts = favoriteProducts.filter(
        (fp) => !productsToRemove.some((pr) => pr.info.id === fp.info.id)
      );
    }

    return favoriteProducts;
  }

}
